import { memo } from 'react'
import clsx from 'clsx'
import moment from 'moment'
import PropTypes from 'prop-types'
import Chart from 'react-apexcharts'
// import ApexCharts from 'apexcharts'
// import PerfectScrollbar from 'react-perfect-scrollbar'
// import { fixedNum, europeNum } from 'src/utils/general'
import { basicColors } from 'src/theme'
import LoadingCard from 'src/components/LoadingCard'
import {
  // Avatar,
  // colors,
  Box,
  // Button,
  // Tooltip,
  Card,
  CardHeader,
  // CardContent,
  // Typography,
  makeStyles,
  useMediaQuery
  // withStyles,
} from '@material-ui/core'
// import { useSnackbar } from 'notistack'

// import {
//  // Edit as EditIcon,
//  WifiOff as DisconnectedIcon,
// } from 'react-feather'

// variaible con le dimenzioni del grafico
const graphSize = {
  height: 280,
  width: 600
}

// variabile con il format per il periodo
const periodXFormat = {
  live: 'HH:mm',
  week: 'dd/MM',
  month: 'dd/MM',
  year: 'MM/yy'
}

// stile CSS generale
const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    maxHeight: '100%',
    width: '100%',
    '& .apexcharts-marker, & .apexcharts-bubble, & circle': {
      cursor: 'pointer',
      pointerEvents: 'all'
    }
  },
  boxContainer: {
    width: '100%',
    height: 'calc(100% - 48px)',
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 16,
    zIndex: 1000,
    '& .apexcharts-marker, & .apexcharts-bubble, & circle': {
      cursor: 'pointer',
      pointerEvents: 'all'
    }
  }
}))

// componente principale
const TimeDistributionGraphView = ({
  isLoading = false,
  noCard = false,
  width = null,
  height = null,
  className,
  timeDistribution,
  anomaliesCategoryStatus,
  anomaliesPeriod,
  selectedDate,
  ...rest
}) => {
  // console.log('showTable =>', showTable)
  const classes = useStyles()
  const isDownSm = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const isDownMd = useMediaQuery((theme) => theme.breakpoints.down('md'))
  const isDownLg = useMediaQuery((theme) => theme.breakpoints.down('lg'))

  const minBubbleRadius = isDownSm ? 7 : (isDownMd ? 8 : (isDownLg ? 9 : 9))
  const maxBubbleRadius = isDownSm ? 16 : (isDownMd ? 18 : (isDownLg ? 19 : 20))
  const ringOffset = isDownSm ? 2 : 2.5

  // const { enqueueSnackbar } = useSnackbar()
  const refDate = selectedDate ? moment(selectedDate) : moment()
  // variabile che specifica il livello di severity nella Y
  // const severityNum = [2, 5, 8, 11, 14]
  let isAllNull = true
  timeDistribution.forEach((category) => {
    if (category && category.data && category.data.length > 0) {
      if (category.data.some((d) => d && d.z !== null && d.z !== undefined && Number(d.z) > 0)) {
        isAllNull = false
      }
    }
  })
  // console.log('IS ALL NULL => ', isAllNull)

  // var dataSet = JSON.parse(JSON.stringify(timeDistribution))
  let chartData = {
    series: timeDistribution[0] && !isAllNull ? JSON.parse(JSON.stringify(timeDistribution)) : [],
    chart: {
      height: graphSize.height,
      width: graphSize.width,
      type: 'bubble'
    },
    options: {
      chart: {
        id: 'bubbleDisserviceHours',
        width: '100%',
        height: 'auto',
        toolbar: {
          show: false
        },
        animations: {
          enabled: false
        },
        zoom: {
          enabled: false
        }
        // events: {
        //   legendClick: function (chartContext, seriesIndex, config) {}
        // }
      },
      colors: [],
      labels: [],
      plotOptions: {
        bubble: {
          minBubbleRadius,
          maxBubbleRadius
        }
      },
      stroke: {
        show: true,
        width: 2.5
      },
      markers: {
        strokeColors: [],
        strokeWidth: 2.5,
        hover: {
          sizeOffset: 3
        }
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'solid',
        opacity: 0
      },
      states: {
        hover: {
          filter: {
            type: 'lighten',
            value: 0.2
          }
        }
      },
      tooltip: {
        theme: 'dark',
        // inverseOrder: true,
        // followCursor: true,
        intersect: true,
        shared: false,
        onDatasetHover: {
          highlightDataSeries: false
        },
        marker: {
          show: true
        },
        x: {
          show: true,
          // format: 'dd/MM/yyyy HH:mm',
          formatter: function (value) {
            return value ? moment(value).format('DD/MM/yyyy HH:mm') : value
          }
        },
        // y: {
        //  title: {
        //   formatter: (seriesName) => '',
        //  },
        // },
        z: {
          title: 'Sv: '
        },
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const pt = w.config.series[seriesIndex]?.data?.[dataPointIndex]
          if (!pt || pt.y === null || typeof pt.y === 'undefined') {
            return ''
          }
          const thisDate = pt.x
          const thisSev = pt.y
          const thisPoints = []
          // carico il titolo
          thisPoints.push(
            '<div class="arrow_box" style="padding-bottom: 4px;">' +
            `<p style="font-size: 13px; color: ${basicColors.primary};">Severity: ${thisSev}<p/>` +
            '</div>'
          )
          // mi trovo tutte le serie che hanno almeno 1 dato che matcha questa severity e questo periodo
          const dataForPoints = {}
          // mi scorro le serie
          w.config.series.forEach((serie) => {
            (serie.data || []).forEach((data) => {
              if (
                data &&
                data.x === thisDate &&
                data.y === thisSev &&
                data.z !== 0 &&
                data.z !== null &&
                data.y !== null
              ) {
                const count = data.realZ !== undefined ? data.realZ : data.z
                if (dataForPoints[count]) {
                  dataForPoints[count].push({
                    color: serie.color,
                    name: serie.name
                  })
                } else {
                  dataForPoints[count] = [
                    {
                      color: serie.color,
                      name: serie.name
                    }
                  ]
                }
              }
            })
          })
          // mi costruisco l'array dei tooltip
          Object.keys(dataForPoints).forEach((anomaliesNum) => {
            // inseriesco il numero di anomalie
            thisPoints.push(
              '<div class="arrow_box" style="padding-bottom: 4px; padding-top: 4px;">' +
              `<p style="font-weight: 600; font-size: 12px; color: ${basicColors.primary}">${anomaliesNum} ${
                Number(anomaliesNum) > 1 ? 'anomalie' : 'anomalia'
              } per:<p/>`
            )
            dataForPoints[anomaliesNum].forEach((serie) => {
              thisPoints.push(`<span style="font-size: 12px; color: ${serie.color};">${serie.name}</span><br />`)
            })
            // chiudo il div
            thisPoints.push('</div>')
          })
          // chiudo con un po' di padding
          thisPoints.push('<div style="padding-top: 4px;"></div>')
          return thisPoints.join('')
        }
      },
      xaxis: {
        type: 'datetime',
        // tickPlacement: 'between',
        // tickAmount:
        //  anomaliesPeriod === 'live'
        //   ? 24
        //   : anomaliesPeriod === 'week'
        //   ? 7
        //   : anomaliesPeriod === 'month'
        //   ? 31
        //   : anomaliesPeriod === 'year'
        //   ? 12
        //   : 7,
        labels: {
          show: true,
          datetimeUTC: false,
          showDuplicates: false,
          style: {
            colors: basicColors.whiteText
          },
          // formatter: function(val) {
          //  return val ? moment(val).format(periodXFormat[anomaliesPeriod]) : val
          // },
          format: periodXFormat[anomaliesPeriod]
        },
        crosshairs: {
          show: true,
          width: 1,
          position: 'back',
          opacity: 0.9,
          stroke: {
            color: '#b6b6b6',
            width: 1,
            dashArray: 0
          },
          fill: {
            type: 'solid',
            color: '#B1B9C4',
            gradient: {
              colorFrom: '#D8E3F0',
              colorTo: '#BED1E6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5
            }
          }
        },
        tooltip: {
          enabled: true,
          style: {
            fontSize: 12
            // fontFamily: 0,
          }
        }
      },
      yaxis: {
        min: 0,
        max: 6,
        tickAmount: 6,
        labels: {
          show: true,
          maxWidth: 160,
          offsetX: 2,
          offsetY: 1,
          style: {
            colors: basicColors.whiteText
          },
          formatter: (val) => {
            // let count = -1
            // let last
            // let value = ''
            // for (var s = val; s >= 2; s -= 3) {
            //  //console.log('s vale: ', s)
            //  count++
            //  last = s
            // }
            // if (last === 2) {
            //  // console.log('count vale: ', count)
            //  value = 'Sv.' + (count + 1)
            // }
            let value = 'Sv.' + val
            if (val === 0 || val === 6) {
              value = ''
            }
            return value
          }
        }
      },
      grid: {
        show: true,
        borderColor: 'rgba(0,0,0,0.35)',
        // row: {
        //  colors: [],
        //  opacity: 0.3,
        // },
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        }
      },
      legend: {
        showForNullSeries: false,
        showForZeroSeries: false,
        offsetY: 20,
        fontSize: '11px',
        position: 'top',
        horizontalAlign: 'center',
        // height: 40,
        labels: {
          colors: [basicColors.whiteText]
        },
        // markers: {
        //  onClick: function(chart, seriesIndex, opts) {
        //   console.log('chart => ', chart)
        //   console.log('chaseriesIndexrt => ', seriesIndex)
        //   console.log('opts => ', opts)
        //  },
        // },
        onItemClick: {
          toggleDataSeries: false
        }
      }
    }
  }

  const normalizeData = function (newChartData) {
    let maxDate, minDate
    newChartData.options.colors = []
    newChartData.options.labels = []
    newChartData.options.markers.strokeColors = []

    // 1. Filtraggio e memorizzazione del realZ (conteggio reale anomalie per serie)
    newChartData.series.forEach((serie, index) => {
      serie.data = (serie.data || [])
        .filter((data) => data && data.z !== null && data.z !== undefined && Number(data.z) > 0)
        .map((data) => ({
          ...data,
          realZ: Number(data.z)
        }))

      const thisCategory = anomaliesCategoryStatus.find((category) => {
        return category.name === serie.category
      })
      if (thisCategory) {
        const thisSubCategory = thisCategory.subCategory.find((subCategory) => {
          return subCategory.name === serie.name
        })
        if (thisSubCategory) {
          newChartData.options.colors.push(thisSubCategory.color)
          newChartData.series[index].color = thisSubCategory.color
          newChartData.series[index].name = thisSubCategory.label
          newChartData.options.labels[index] = thisSubCategory.label
          newChartData.options.markers.strokeColors.push(thisSubCategory.color)
        } else {
          newChartData.options.colors.push(basicColors.primary)
          newChartData.options.markers.strokeColors.push(basicColors.primary)
        }
      } else {
        newChartData.options.colors.push(basicColors.primary)
        newChartData.options.markers.strokeColors.push(basicColors.primary)
      }
    })

    // 2. Calcolo raggio base e gestione dei cerchi concentrici (Opzione A - Pari merito e sovrapposizioni)
    const pointsByCoord = {}
    newChartData.series.forEach((serie) => {
      (serie.data || []).forEach((data) => {
        const key = `${data.x}_${data.y}`
        if (!pointsByCoord[key]) {
          pointsByCoord[key] = []
        }
        pointsByCoord[key].push(data)
      })
    })

    Object.keys(pointsByCoord).forEach((key) => {
      const group = pointsByCoord[key]
      if (group.length === 1) {
        // Singolo punto: raggio proporzionale al numero di anomalie (realZ)
        const count = group[0].realZ || 1
        group[0].z = minBubbleRadius + Math.min(maxBubbleRadius - minBubbleRadius, (count - 1) * 2.5)
      } else {
        // Più serie alle stesse coordinate (x, y):
        // Ordiniamo per numero di anomalie crescente
        group.sort((a, b) => a.realZ - b.realZ)

        let prevRadius = 0
        group.forEach((pt, i) => {
          const count = pt.realZ || 1
          const baseRadius = minBubbleRadius + Math.min(maxBubbleRadius - minBubbleRadius, (count - 1) * 2.5)

          if (i === 0) {
            pt.z = baseRadius
            prevRadius = baseRadius
          } else {
            // Offset concentrico: ogni cerchio successivo si allarga di ringOffset px rispetto al precedente
            const nextRadius = Math.max(baseRadius, prevRadius + ringOffset)
            const maxAllowed = maxBubbleRadius + (i * ringOffset)
            pt.z = Math.min(nextRadius, maxAllowed)
            prevRadius = pt.z
          }
        })
      }
    })

    // 3. Min e max dell'asse temporale X
    minDate = moment(refDate).set({ hours: 0, minute: 0, second: 0, millisecond: 1 })
    maxDate = moment(refDate).set({
      hours: 23,
      minute: 59,
      second: 59,
      millisecond: 900
    })
    if (anomaliesPeriod === 'live') {
      minDate = moment(minDate).subtract(1, 'h')
      maxDate = moment(maxDate).add(1, 'h')
    } else if (anomaliesPeriod === 'week') {
      minDate = moment(minDate).startOf('week').subtract(1, 'd')
      maxDate = moment(maxDate).endOf('week').set({ hours: 0, minute: 0, second: 0, millisecond: 1 }).add(1, 'd')
    } else if (anomaliesPeriod === 'month') {
      minDate = moment(minDate).startOf('month').subtract(1, 'd')
      maxDate = moment(maxDate).endOf('month').set({ hours: 0, minute: 0, second: 0, millisecond: 1 }).add(1, 'd')
    } else if (anomaliesPeriod === 'year') {
      minDate = moment(minDate).startOf('year').subtract(1, 'M')
      maxDate = moment(maxDate).endOf('year').set({ hours: 0, minute: 0, second: 0, millisecond: 1 }).add(1, 'M')
    }

    newChartData.options.xaxis.min = moment(minDate).unix() * 1000
    newChartData.options.xaxis.max = moment(maxDate).unix() * 1000

    // 4. Punti di ancoraggio invisibili (y: null) per calibrare zRatio = 1 in ApexCharts
    const maxAnchorZ = maxBubbleRadius
    const firstActiveSeries = newChartData.series.find((s) => s.data && s.data.length > 0)
    if (firstActiveSeries) {
      firstActiveSeries.data.push(
        { x: moment(minDate).unix() * 1000, y: null, z: minBubbleRadius },
        { x: moment(maxDate).unix() * 1000, y: null, z: maxAnchorZ }
      )
    }

    return newChartData
  }
  chartData = normalizeData(chartData)
  // console.log('time chartData => ', chartData)

  return noCard
    ? (!isLoading && timeDistribution[0] !== '-')
        ? (
          <Chart
            id={chartData.options.chart.id}
            options={chartData.options}
            series={chartData.series}
            type={chartData.chart.type}
            width={width || '100%'}
            height={height || '100%'}
          />
          )
        : (
          <LoadingCard />
          )
    : (
      <Card className={clsx(classes.root, className)} {...rest}>
        <CardHeader
          title='DISTRIBUZIONE NEL TEMPO'
          titleTypographyProps={{ style: { textTransform: 'uppercase' } }}
          // subheader='September 14, 2016'
          style={{ paddingBottom: 0 }}
        />
        <Box className={classes.boxContainer}>
          {!isLoading && timeDistribution[0] !== '-'
            ? (
              <Chart
                id={chartData.options.chart.id}
                options={chartData.options}
                series={chartData.series}
                type={chartData.chart.type}
                width='100%'
                height='100%'
              />
              )
            : (
              <LoadingCard />
              )}
        </Box>
      </Card>
      )
}

TimeDistributionGraphView.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  anomaliesPeriod: PropTypes.string,
  selectedDate: PropTypes.object,
  timeDistribution: PropTypes.array,
  anomaliesCategoryStatus: PropTypes.array
  // setRefreshUsers: PropTypes.func
}

TimeDistributionGraphView.defaultProps = {
  isLoading: false,
  anomaliesPeriod: 'live',
  selectedDate: null,
  timeDistribution: [],
  anomaliesCategoryStatus: []
}

export default memo(TimeDistributionGraphView)
